import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";
import { setActivity } from "../../widgets/DashboardComponents/V3/ActivityLogWidget/actions";
import {
    Typography,
    Grid,
    Button,
    Snackbar,
    MenuItem,
    SnackbarContent,
    Select,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    TextField,
} from "@material-ui/core";
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";
import { Report as ListIcon, Navigation as GoToIcon } from "@material-ui/icons";
import {
    getJobPack,
    getNewJobPackID,
    setJobPack,
    setJobType,
    createJobType,
    getJobTypes,
    getUsers,
    setEventUpdates,
    getToolboxTalks,
    getAllQualifications,
    setJobPackNew,
    getTotalJobPackCount,
    setJobPackCount,
} from "./actions";
import moment from "moment";
import PrintIcon from "@material-ui/icons/Print";
import ReactToPrint from "react-to-print";
import {
    StyledCard,
    StyledContent,
    StyledViewContainer,
    StyledHeader,
} from "../../styles";
let date = new Date();
let newYear = moment(date).format("YYYY");
let newMonth = moment(date).format("MMM").toLowerCase();
const currentDate = moment().format("DD-MM-YYYY");
const QRCode = require("qrcode.react");

class JobPackV3 extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getToolboxTalks();
        props.getTotalJobPackCount();
        props.getAllQualifications();
        props.setJobType("new_job_pack");
        let profiles = props.blankProfile;
        let pageType = props.match.params.type;
        console.log(props.history);
        let posting = false;
        if (pageType === "create") {
            props.getNewJobPackID(props.match.params.status);
        } else if (pageType === "posting") {
            props.getNewJobPackID(props.match.params.status);

            posting = props.history.location.state.posting;
            Object.keys(posting).map((key) => {
                if (!["event_id", "track_id"].includes(key))
                    profiles[key] = posting[key];
                return null;
            });
        } else {
            props.getJobPack(
                props.match.params.uid,
                props.match.params.status,
                props.match.params.year,
                props.match.params.month
            );
        }
        this.state = {
            edit: pageType === "view" ? false : true,
            jobType: "jobpack",
            rulesNotMet: false,
            pageType: pageType,
            profile: profiles,
            template_title: "",
            selectedJob: false,
            brokenRules: [],
            jobPosting: posting,
        };

        props.getJobTypes();
        // props.getAllJobPackIds();
        // props.getAllJobPendingIds();
        // props.getAllJobArchivedIds();
    }
    goBack() {
        this.props.history.goBack();
    }
    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.pageType === "create" &&
            this.state.profile.job_id !== this.props.newJobPackID
        ) {
            let profile = this.props.blankProfile;
            profile.job_id = this.props.newJobPackID;
            // let colorVal = this.props.colors[
            //     parseInt(
            //         this.props.newJobPackID[this.props.newJobPackID.length - 1]
            //     )
            // ];
            // profile.calendar_color = colorVal;
            this.setState({ profile });
        } else if (
            (this.state.pageType === "view" ||
                this.state.pageType === "edit") &&
            prevProps.jobPack !== this.props.jobPack
        ) {
            this.setState({ profile: this.props.jobPack });
        } else if (
            this.state.pageType === "posting" &&
            this.state.profile.job_id !== this.props.newJobPackID
        ) {
            let profile = this.state.profile;
            profile.job_id = this.props.newJobPackID;
            this.setState({ profile });
        }
        if (
            this.state.pageType === "create" &&
            this.state.selectedJob !== this.props.job &&
            this.props.jobTypes &&
            this.props.job !== "new_job_pack"
        ) {
            let profile = this.state.profile;
            let selectedJob = this.props.job;
            this.setState({ selectedJob });
            if (this.props.jobTypes[selectedJob])
                Object.keys(this.props.jobTypes[selectedJob].profile).map(
                    (key) => {
                        profile[key] = this.props.jobTypes[selectedJob].profile[
                            key
                        ];
                        return null;
                    }
                );
            profile.job_type = this.props.jobTypes[selectedJob]
                ? this.props.jobTypes[selectedJob].title
                : "";
            profile.job_id = this.props.newJobPackID;

            this.props.setRules(this.props.jobTypes[selectedJob].rules);
            this.setState({ profile });
            let canvas = document.getElementById("QRCODE");
            profile.job_id = this.props.newJobPackID;
            this.setState({ profile });
            if (canvas) profile.qr_code_url = canvas.toDataURL();
            this.setState({ profile });
        } else if (
            this.state.pageType === "create" &&
            this.state.selectedJob !== this.props.job &&
            this.props.job === "new_job_pack"
        ) {
            let selectedJob = this.props.job;
            this.setState({ selectedJob });
            let canvas = document.getElementById("QRCODE");
            let profile = this.props.blankProfile;

            profile.job_id = this.props.newJobPackID;
            this.setState({ profile });
            if (canvas) profile.qr_code_url = canvas.toDataURL();
            this.setState({ profile });
        } else if (
            this.state.pageType === "posting" &&
            this.state.selectedJob !== this.props.job &&
            this.props.jobTypes &&
            this.props.job !== "new_job_pack"
        ) {
            let profile = this.state.profile;
            let selectedJob = this.props.job;
            this.setState({ selectedJob });
            Object.keys(this.props.jobTypes[selectedJob].profile).map((key) => {
                profile[key] = this.props.jobTypes[selectedJob].profile[key];
                return null;
            });

            profile.job_type = this.props.jobTypes[selectedJob].title;
            profile.job_id = this.props.newJobPackID;

            let canvas = document.getElementById("QRCODE");
            profile.job_id = this.props.newJobPackID;
            this.setState({ profile });
            if (canvas) profile.qr_code_url = canvas.toDataURL();
            this.setState({ profile });
        }
    }
    resetData = () => {
        let profile = this.state.profile;
        Object.keys(profile).map((e) => {
            if (Array.isArray(profile[e])) {
                profile[e] = [];
            } else if (typeof profile[e] === "string") {
                profile[e] = "";
            } else {
            }
            return null;
        });
        if (profile["start_date"] === "") {
            profile["start_date"] = currentDate;
        }
        if (profile["end_date"] === "") {
            profile["end_date"] = currentDate;
        }
        profile["status"] = "active";
        profile["job_id"] = this.props.newJobPackID;
        this.setState({ profile });
    };

    checkRulesForNotification() {
        let { profile } = this.state;
        let selectedJob = this.props.job;

        if (this.props.job !== "new_job_pack") {
            let template_rules = this.props.jobTypes[selectedJob].rules;

            if (template_rules && profile.assigned_operatives) {
                let oneflag = false,
                    brokenRules = [];
                template_rules.map((rule, i) => {
                    let broken = false,
                        oneflagBroken = false;
                    if (rule.rule_category === "qualifications") {
                        profile.assigned_operatives.map((op, ind) => {
                            let user = this.props.users[op.uid];

                            let qual = user.profile.qualifications_per_user
                                ? user.profile.qualifications_per_user[
                                      rule.subject_id
                                  ]
                                : false;

                            if (qual) {
                                if (rule.applied_to === "all") {
                                    if (
                                        qual.qualification_verified === "No" ||
                                        moment(
                                            qual.qualification_exp_date,
                                            "DD/MM/YYYY"
                                        ).isValid === false
                                    ) {
                                        broken = true;
                                    } else if (
                                        !moment(
                                            qual.qualification_exp_date,
                                            "DD/MM/YYYY"
                                        ).isSameOrAfter(
                                            moment(
                                                profile.end_date,
                                                "DD-MM-YYYY"
                                            )
                                        )
                                    ) {
                                        broken = true;
                                    }
                                } else {
                                    if (
                                        qual.qualification_verified === "Yes" &&
                                        moment(
                                            qual.qualification_exp_date,
                                            "DD/MM/YYYY"
                                        ).isValid
                                    ) {
                                        oneflagBroken = true;
                                    } else if (
                                        qual.qualification_exp_date !== "N/A" &&
                                        moment(
                                            qual.qualification_exp_date,
                                            "DD/MM/YYYY"
                                        ).isSameOrAfter(
                                            moment(
                                                profile.end_date,
                                                "DD-MM-YYYY"
                                            )
                                        )
                                    ) {
                                        oneflagBroken = true;
                                    }
                                }
                            }

                            return null;
                        });
                        if (typeof profile.assigned_supervisor === "object") {
                            if (profile.assigned_supervisor.uid !== "") {
                                let user = this.props.users[
                                    profile.assigned_supervisor.uid
                                ];
                                let qual = user.profile.qualifications_per_user
                                    ? user.profile.qualifications_per_user[
                                          rule.subject_id
                                      ]
                                    : false;

                                if (qual) {
                                    if (rule.applied_to === "all") {
                                        if (
                                            qual.qualification_verified ===
                                                "No" ||
                                            moment(
                                                qual.qualification_exp_date,
                                                "DD/MM/YYYY"
                                            ).isValid === false
                                        ) {
                                            broken = true;
                                        } else if (
                                            !moment(
                                                qual.qualification_exp_date,
                                                "DD/MM/YYYY"
                                            ).isSameOrAfter(
                                                moment(
                                                    profile.end_date,
                                                    "DD-MM-YYYY"
                                                )
                                            )
                                        ) {
                                            broken = true;
                                        }
                                    } else {
                                        if (
                                            qual.qualification_verified ===
                                                "Yes" &&
                                            moment(
                                                qual.qualification_exp_date,
                                                "DD/MM/YYYY"
                                            ).isValid === true
                                        ) {
                                            oneflagBroken = true;
                                        } else if (
                                            moment(
                                                qual.qualification_exp_date,
                                                "DD/MM/YYYY"
                                            ).isValid === true &&
                                            moment(
                                                qual.qualification_exp_date,
                                                "DD/MM/YYYY"
                                            ).isSameOrAfter(
                                                moment(
                                                    profile.end_date,
                                                    "DD-MM-YYYY"
                                                )
                                            )
                                        ) {
                                            oneflagBroken = true;
                                        }
                                    }
                                }
                            }
                        }

                        if (oneflagBroken) oneflag = true;
                        if (oneflag === false && rule.applied_to === "one")
                            broken = true;

                        if (broken) brokenRules.push(rule);
                    } else {
                        profile.assigned_operatives.map((op) => {
                            let uid = op.uid;
                            if (this.props.toolboxes) {
                                let reports =
                                    _.get(
                                        this.props.toolboxes[rule.subject_id],
                                        "reports"
                                    ) || null;
                                if (reports) {
                                    Object.keys(reports).map((e) => {
                                        let attendees = reports[e].attendance
                                            ? reports[e].attendance
                                            : null;

                                        if (rule.applied_to === "all") {
                                            if (attendees) {
                                                if (
                                                    !attendees
                                                        .map((e) => {
                                                            return e.uid;
                                                        })
                                                        .includes(uid)
                                                ) {
                                                    broken = true;
                                                }
                                            } else {
                                                broken = true;
                                            }
                                        } else {
                                            if (attendees) {
                                                if (
                                                    attendees
                                                        .map((e) => {
                                                            return e.uid;
                                                        })
                                                        .includes(uid)
                                                ) {
                                                    oneflagBroken = true;
                                                }
                                            }
                                        }

                                        return null;
                                    });
                                } else broken = true;
                            }
                            return null;
                        });
                        if (typeof profile.assigned_supervisor === "object") {
                            if (profile.assigned_supervisor.uid !== "") {
                                let uid = profile.assigned_supervisor.uid;

                                if (this.props.toolboxes) {
                                    let reports =
                                        _.get(
                                            this.props.toolboxes[
                                                rule.subject_id
                                            ],
                                            "reports"
                                        ) || null;
                                    if (reports)
                                        Object.keys(reports).map((e) => {
                                            let attendees = reports[e]
                                                .attendance
                                                ? reports[e].attendance
                                                : null;
                                            if (attendees) {
                                                if (rule.applied_to === "all") {
                                                    if (
                                                        !attendees
                                                            .map((e) => {
                                                                return e.uid;
                                                            })
                                                            .includes(uid)
                                                    ) {
                                                        broken = true;
                                                    }
                                                } else {
                                                    if (
                                                        attendees
                                                            .map((e) => {
                                                                return e.uid;
                                                            })
                                                            .includes(uid)
                                                    ) {
                                                        oneflagBroken = true;
                                                    }
                                                }
                                            }
                                            return null;
                                        });
                                    else broken = true;
                                }
                            }
                        }

                        if (oneflagBroken) oneflag = true;
                        if (oneflag === false && rule.applied_to === "one")
                            broken = true;

                        if (broken) brokenRules.push(rule);

                        return false;
                    }

                    return null;
                });

                this.setState({ brokenRules });
                return brokenRules.length > 0;
            } else return false;
        } else return false;
    }
    render() {
        const { profile, edit, jobType } = this.state;
        const {
            jobTypes,
            job,
            setJobPackType,
            userProfile,
            count,
        } = this.props;
       
        return (
            <>
                <div ref={(el) => (this.componentRef = el)}>
                    <StyledCard>
                        <Modal
                            isOpen={this.props.requesting}
                            style={{ maxWidth: "00px" }}
                        >
                            <ModalBody>
                                <div
                                    style={{
                                        textAlign: "center",
                                        paddingTop: "3em",
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            width: "fit-content",
                                            display: "inline-block",
                                            padding: "2em",
                                        }}
                                    >
                                        <Spinner
                                            style={{
                                                height: 100,
                                                width: 100,
                                                background: "white",
                                            }}
                                            color="primary"
                                        />
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                marginTop: 15,
                                                color: "rgba(0, 0, 0, 0.87)",
                                                fontWeight: "bolder",
                                                fontSize: 20,
                                            }}
                                            variant="subtitle1"
                                        >
                                            Processing...
                                        </Typography>
                                    </div>
                                </div>
                            </ModalBody>
                        </Modal>
                        {profile && (
                            <>
                                <StyledHeader style={{ background: "#0188cc" }}>
                                    <Typography
                                        variant="h6"
                                        style={{ color: "white" }}
                                    >
                                        Jobpack ID: {profile.job_id} ,&nbsp;&nbsp;
                                        Jobpack URN: {profile.urn}
                                        <ReactToPrint
                                            onBeforePrint={() => {
                                                setTimeout(undefined, 2000);
                                            }}
                                            trigger={() => (
                                                <PrintIcon
                                                    style={{
                                                        float: "right",
                                                        fontSize: "36px",
                                                        marginRight: "30px",
                                                        cursor: "pointer",
                                                        color: "white",
                                                    }}
                                                />
                                            )}
                                            content={() => this.componentRef}
                                        />
                                        <div
                                            style={{
                                                borderRadius: 4,
                                                height: "100%",
                                                display: "inline",
                                                overflow: "hidden",
                                                position: "relative",
                                                fontSize: "16px",
                                                fontWeight: "700",
                                                marginLeft: 24,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "60px",
                                                    minWidth: "120px",
                                                    border: "1px solid white",
                                                    padding: 12,
                                                    borderBottomLeftRadius: 4,
                                                    borderTopLeftRadius: 4,
                                                    display: "inline",
                                                    position: "relative",
                                                    color:
                                                        jobType === "jobpack"
                                                            ? "#0188cc"
                                                            : "inherit",
                                                    background:
                                                        jobType === "jobpack"
                                                            ? "white"
                                                            : "inherit",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    this.setState({
                                                        jobType: "jobpack",
                                                    });
                                                    setJobPackType("jobpack");
                                                }}
                                            >
                                                Create Jobpack
                                            </div>
                                            <div
                                                style={{
                                                    cursor: "pointer",
                                                    minHeight: "100%",
                                                    minWidth: "120px",
                                                    borderRight:
                                                        "1px solid white",
                                                    borderBottom:
                                                        "1px solid white",
                                                    borderTop:
                                                        "1px solid white",
                                                    borderBottomRightRadius: 4,
                                                    borderTopRightRadius: 4,
                                                    padding: 12,
                                                    display: "inline",
                                                    position: "relative",
                                                    color:
                                                        jobType === "template"
                                                            ? "#0188cc"
                                                            : "inherit",
                                                    background:
                                                        jobType === "template"
                                                            ? "white"
                                                            : "inherit",
                                                }}
                                                onClick={() => {
                                                    setJobPackType("template");
                                                    this.setState({
                                                        jobType: "template",
                                                    });
                                                }}
                                            >
                                                Create Template
                                            </div>
                                        </div>
                                    </Typography>
                                </StyledHeader>
                            </>
                        )}
                        <StyledContent>
                            <StyledViewContainer>
                                {this.state.pageType !== "view" && (
                                    <Select
                                        style={{ marginTop: 15, minWidth: 150 }}
                                        value={job}
                                        label="Job Type"
                                        onChange={(event) => {
                                            if (
                                                event.target.value ===
                                                "new_job_pack"
                                            )
                                                this.resetData();
                                            this.props.setJobType(
                                                event.target.value
                                            );
                                        }}
                                    >
                                        <MenuItem
                                            key={"new_job_pack"}
                                            value={"new_job_pack"}
                                        >
                                            New Jobpack
                                        </MenuItem>
                                        {jobTypes &&
                                            Object.keys(jobTypes).map((e) => {
                                                return (
                                                    <MenuItem
                                                        key={jobTypes[e].title}
                                                        value={e}
                                                    >
                                                        {jobTypes[e].title}
                                                    </MenuItem>
                                                );
                                            })}
                                            
                                    </Select>
                                )}
                                <QRCode
                                    id="QRCODE"
                                    bgColor="#FFFFFF"
                                    fgColor="#000000"
                                    level="Q"
                                    style={{
                                        width: 150,
                                        height: 150,
                                        display: "none",
                                    }}
                                    includeMargin={true}
                                    size={512}
                                    imageSettings={{
                                        height: 500,
                                        width: 500,
                                    }}
                                    value={profile.job_id || ""}
                                    renderAs="canvas"
                                />
                            </StyledViewContainer>

                            <StyledViewContainer>
                                <Grid container spacing={5}>
                                    {profile &&
                                        this.props.children(
                                            this.state.profile,
                                            this.state.edit,
                                            (key, value) => {
                                                let profile = {
                                                    ...this.state.profile,
                                                    [key]: value,
                                                };
                                                this.setState({
                                                    profile,
                                                });
                                            }
                                        )}
                                </Grid>
                            </StyledViewContainer>
                            <StyledViewContainer>
                                <Button
                                    style={{ marginRight: 15 }}
                                    variant="contained"
                                    onClick={() => {
                                        this.goBack();
                                    }}
                                >
                                    {edit ? "Cancel" : "Jobpack Manager"}
                                </Button>
                                {edit &&
                                this.state.jobType === "jobpack" &&
                                (this.state.pageType === "create" ||
                                    this.state.pageType === "posting") ? (
                                    <Button
                                        style={{ marginRight: 15 }}
                                        variant="contained"
                                        color="primary"
                                        disabled={
                                            this.state.profile.start_date ===
                                                "" ||
                                            this.state.profile.end_date === ""
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            let ruling = this.checkRulesForNotification();

                                            let prof = this.state.profile;
                                            prof.created_by = {
                                                user_name:
                                                    userProfile.first_name +
                                                    " " +
                                                    userProfile.last_name,
                                                user_uid: userProfile.uid,
                                                platform: "Dashboard",
                                            };
                                            let urnCount = this.state.profile;
                                            let intialName = this.state.profile.created_by.user_name.split(
                                                " "
                                            );
                                            let firstName = intialName[0].substring(
                                                0,
                                                2
                                            );
                                            let lastName = intialName[1].substring(
                                                0,
                                                2
                                            );
                                            let fullName =
                                                userProfile.nick_name &&
                                                userProfile.nick_name !== ""
                                                    ? userProfile.nick_name
                                                    : firstName + lastName;
                                            let newURNCount = (
                                                Number(count) + 1
                                            )
                                                .toString()
                                                .padStart(6, "0");
                                            urnCount.urn = `JOB-${fullName}-${newURNCount}`;

                                            if (ruling) {
                                                this.setState({
                                                    rulesNotMet: true,
                                                });
                                            } else
                                                this.props.setJobPackNew(
                                                    this.props.match.params
                                                        .status,
                                                    this.state.profile,
                                                    this.props.blankProfile,
                                                    this.state.pageType,
                                                    newYear,
                                                    newMonth,
                                                    (success) => {
                                                        if (success) {
                                                            if (
                                                                this.state
                                                                    .pageType ===
                                                                "posting"
                                                            ) {
                                                                let post = this
                                                                    .state
                                                                    .jobPosting;
                                                                [
                                                                    "assigned_operatives",
                                                                    "assigned_supervisor",
                                                                    "assigned_manager",
                                                                    "start_date",
                                                                    "end_date",
                                                                    "job_vehicles",
                                                                    "job_name",
                                                                    "job_id",
                                                                    "address",
                                                                    "location_lat",
                                                                    "location_long",
                                                                ].map((e) => {
                                                                    post[
                                                                        e
                                                                    ] = this.state.profile[
                                                                        e
                                                                    ];
                                                                    return null;
                                                                });
                                                                this.props.setEventUpdates(
                                                                    post,
                                                                    (
                                                                        success
                                                                    ) => {
                                                                        if (
                                                                            success
                                                                        ) {
                                                                            this.setState(
                                                                                {
                                                                                    uploadSuccess: true,
                                                                                }
                                                                            );
                                                                        } else {
                                                                            this.setState(
                                                                                {
                                                                                    uploadFail: true,
                                                                                }
                                                                            );
                                                                        }
                                                                    }
                                                                );
                                                            }
                                                            this.props.setActivity(
                                                                "create",
                                                                "jobpack",
                                                                this.state
                                                                    .profile
                                                                    .job_name
                                                            );
                                                            this.props.setJobPackCount(
                                                                count + 1
                                                            );
                                                            this.setState({
                                                                uploadSuccess: true,
                                                            });
                                                        } else {
                                                            this.setState({
                                                                uploadFail: true,
                                                            });
                                                        }
                                                        this.goBack();
                                                    }
                                                );
                                        }}
                                    >
                                        Submit
                                    </Button>
                                ) : edit && this.state.jobType === "jobpack" ? (
                                    <Button
                                        style={{ marginRight: 15 }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.props.setJobPack(
                                                this.props.match.params.status,
                                                this.state.profile,
                                                this.props.blankProfile,
                                                this.state.pageType,
                                                this.props.match.params.year,
                                                this.props.match.params.month,
                                                (success) => {
                                                    if (success) {
                                                        this.props.setActivity(
                                                            "update",
                                                            "jobpack",
                                                            this.state.profile
                                                                .job_name
                                                        );
                                                        this.setState({
                                                            uploadSuccess: true,
                                                        });
                                                    } else {
                                                        this.setState({
                                                            uploadFail: true,
                                                        });
                                                    }
                                                    this.goBack();
                                                }
                                            );
                                        }}
                                    >
                                        Submit
                                    </Button>
                                ) : (
                                    ""
                                )}
                                {edit && this.state.jobType === "template" && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            this.setState({
                                                template_title:
                                                    this.props.job ===
                                                    "new_job_pack"
                                                        ? ""
                                                        : this.props.jobTypes[
                                                              this.props.job
                                                          ].title,
                                                uploadTemplateModal: true,
                                            });
                                        }}
                                    >
                                        {this.props.job === "new_job_pack"
                                            ? "Submit"
                                            : "Edit "}{" "}
                                        Jobpack Type
                                    </Button>
                                )}
                            </StyledViewContainer>
                        </StyledContent>
                        <Snackbar
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            autoHideDuration={6000}
                            open={
                                this.state.uploadSuccess ||
                                this.state.uploadFail
                            }
                            onClose={() => {
                                this.setState({
                                    uploadSuccess: false,
                                    uploadFail: false,
                                });
                            }}
                        >
                            <SnackbarContent
                                style={{
                                    backgroundColor: this.state.uploadSuccess
                                        ? "green"
                                        : this.state.uploadFail
                                        ? "red"
                                        : "white",
                                    color: "white",
                                }}
                                message={
                                    this.state.uploadSuccess
                                        ? "Jobpack Successfully Uploaded"
                                        : this.state.uploadFail
                                        ? "Unable to Upload Jobpack, Please Contact System Admin"
                                        : ""
                                }
                            />
                        </Snackbar>
                        <Modal isOpen={this.state.uploadTemplateModal}>
                            <ModalHeader>Submit Job Type</ModalHeader>
                            <ModalBody>
                                <Typography variant="body1">
                                    Give a title for this job type so it is
                                    identifiable.
                                </Typography>
                                <TextField
                                    value={this.state.template_title}
                                    label={"Job Type Title"}
                                    onChange={(event) => {
                                        this.setState({
                                            template_title: event.target.value,
                                        });
                                    }}
                                />
                            </ModalBody>

                            <ModalFooter>
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            template_title: "",
                                            uploadTemplateModal: false,
                                        });
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    disabled={
                                        this.state.template_title === "" &&
                                        this.props.job === "new_job_pack"
                                    }
                                    onClick={() => {
                                        if (this.props.job === "new_job_pack")
                                            this.props.createJobType(
                                                this.state.profile,
                                                this.state.template_title,
                                                this.props.rules,
                                                (success) => {
                                                    if (success) {
                                                        this.setState({
                                                            template_title: "",
                                                            uploadTemplateSuccess: true,
                                                            uploadTemplateModal: false,
                                                        });
                                                    } else {
                                                        this.setState({
                                                            uploadTemplateFail: true,
                                                            uploadTemplateModal: false,
                                                        });
                                                    }
                                                    this.goBack();
                                                },
                                                false
                                            );
                                        else
                                            this.props.createJobType(
                                                this.state.profile,
                                                this.state.template_title,
                                                this.props.rules,
                                                (success) => {
                                                    if (success) {
                                                        this.setState({
                                                            uploadTemplateSuccess: true,
                                                            uploadTemplateModal: false,
                                                        });
                                                    } else {
                                                        this.setState({
                                                            uploadTemplateFail: true,
                                                        });
                                                    }
                                                    this.goBack();
                                                },
                                                true,
                                                this.props.job
                                            );
                                    }}
                                    variant="contained"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            </ModalFooter>
                        </Modal>
                        <Modal isOpen={this.state.rulesNotMet}>
                            <ModalHeader>
                                Warning: Training Rules have not been adhered
                                too.
                            </ModalHeader>
                            <ModalBody>
                                <Typography variant="body1">
                                    There seem to be a problem with one or many
                                    of your staff where they have not met the
                                    Training Rules criteria assigned to this Job
                                    Template.
                                    <br />
                                    Broken Rules are listed Below:
                                </Typography>
                                <List>
                                    {this.state.brokenRules &&
                                        this.state.brokenRules.map((e) => {
                                            return (
                                                <ListItem>
                                                    <ListItemIcon>
                                                        <ListIcon
                                                            style={{
                                                                color: "red",
                                                            }}
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={`${
                                                            e.applied_to ===
                                                            "all"
                                                                ? "Every Member must have a "
                                                                : "At Least, one member must have a "
                                                        }${
                                                            e.rule_category ===
                                                            "qualifications"
                                                                ? "Qualification of "
                                                                : "Toolbox Talk with ID "
                                                        } ${
                                                            e.rule_category ===
                                                                "qualifications" &&
                                                            this.props.allQuals[
                                                                e.subject_id
                                                            ]
                                                                ? this.props
                                                                      .allQuals[
                                                                      e
                                                                          .subject_id
                                                                  ]
                                                                      .qualification_title
                                                                : ""
                                                        }
                                                ${
                                                    e.rule_category ===
                                                        "toolboxes" &&
                                                    this.props.toolboxes[
                                                        e.subject_id
                                                    ]
                                                        ? this.props.toolboxes[
                                                              e.subject_id
                                                          ].profile
                                                              .toolbox_topic
                                                        : ""
                                                }`}
                                                    />
                                                    <ListItemSecondaryAction>
                                                        <Link
                                                            style={{
                                                                padding: 6,
                                                                borderRadius:
                                                                    "50%",
                                                                border:
                                                                    "2px solid #0188cc",
                                                                color:
                                                                    "#0188cc",
                                                            }}
                                                            target="_blank"
                                                            to={
                                                                e.rule_category ===
                                                                "qualifications"
                                                                    ? "/qualifications-manager"
                                                                    : "/toolbox-talks"
                                                            }
                                                        >
                                                            <GoToIcon />
                                                        </Link>
                                                    </ListItemSecondaryAction>
                                                </ListItem>
                                            );
                                        })}
                                </List>
                            </ModalBody>

                            <ModalFooter>
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            rulesNotMet: false,
                                        });
                                    }}
                                >
                                    Review Job Details
                                </Button>
                                <Button
                                    onClick={() => {
                                        let prof = this.state.profile;
                                        prof.client_contact_no =
                                            prof.client_no_prefix +
                                            prof.client_contact_no;
                                        this.props.setJobPackNew(
                                            this.props.match.params.status,
                                            prof,
                                            this.props.blankProfile,
                                            this.state.pageType,
                                            newYear,
                                            newMonth,
                                            (success) => {
                                                if (success) {
                                                    if (
                                                        this.state.pageType ===
                                                        "posting"
                                                    ) {
                                                        let post = this.state
                                                            .jobPosting;
                                                        [
                                                            "assigned_operatives",
                                                            "assigned_supervisor",
                                                            "assigned_manager",
                                                            "start_date",
                                                            "end_date",
                                                            "job_vehicles",
                                                            "job_name",
                                                            "job_id",
                                                            "address",
                                                            "location_lat",
                                                            "location_long",
                                                        ].map((e) => {
                                                            post[
                                                                e
                                                            ] = this.state.profile[
                                                                e
                                                            ];
                                                            return null;
                                                        });
                                                        this.props.setEventUpdates(
                                                            post,
                                                            (success) => {
                                                                if (success) {
                                                                    this.setState(
                                                                        {
                                                                            uploadSuccess: true,
                                                                        }
                                                                    );
                                                                } else {
                                                                    this.setState(
                                                                        {
                                                                            uploadFail: true,
                                                                        }
                                                                    );
                                                                }
                                                            }
                                                        );
                                                    }

                                                    this.setState({
                                                        uploadSuccess: true,
                                                    });
                                                } else {
                                                    this.setState({
                                                        uploadFail: true,
                                                    });
                                                }
                                                this.goBack();
                                            }
                                        );
                                    }}
                                    variant="contained"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </StyledCard>
                </div>
            </>
        );
    }
}

export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectNewJobPackUID,
            selectJobPackProfile,
            selectJobTypes,
            selectedJobType,
            selectAllUsers,
            selectAllToolboxes,
            selectAllQualifications,
            selectRequesting,
            selectProfile,
            selectJobPackCount,
            // selectJobPackAllIds,
            // selectJobPackPendingAllIds,
            // selectJobPackArchivedIds
        } = selectors;
        return {
            newJobPackID: selectNewJobPackUID(store),
            jobPack: selectJobPackProfile(store),
            jobTypes: selectJobTypes(store),
            job: selectedJobType(store),
            users: selectAllUsers(store),
            toolboxes: selectAllToolboxes(store),
            allQuals: selectAllQualifications(store),
            requesting: selectRequesting(store),

            userProfile: selectProfile(store),
            count: selectJobPackCount(store),
            //    activeids: selectJobPackAllIds(store),
            //    pendingids:selectJobPackPendingAllIds(store),
            //    archivedids:selectJobPackArchivedIds(store)
        };
    },
    {
        setJobPack,
        getJobPack,
        getNewJobPackID,
        setJobType,
        createJobType,
        getJobTypes,
        getUsers,
        setEventUpdates,
        setJobPackNew,

        getToolboxTalks,
        getAllQualifications,
        setActivity,
        getTotalJobPackCount,
        setJobPackCount,
        // getAllJobPackIds,
        // getAllJobPendingIds,
        // getAllJobArchivedIds
    }
)(JobPackV3);
